import {  useState, useContext, useEffect } from 'react';
import { LeadsContext } from "../Context/LeadsContext";
import { UserContext } from '../Context/UserContext';
import Fancybox from '../Front/Fancybox';

const TextLead = ({ close, leadData, onAddScriptBtnClick }) => {

    const { textScripts, leadFields, sendSms, numberFormatter, agentData } = useContext(LeadsContext);
    
        const {user} = useContext(UserContext);

    const [selectedOption, setSelectedOption] = useState(0);

    const [textBody,setTextBody] = useState("");

    const [selectedAgentIndex, setSelectedAgentIndex] = useState(0);
        
    const selectAgent = (i) => {

        setSelectedAgentIndex(i);
    }

    const handleSelectChange = (value) => {
        setSelectedOption(value);
        if (value !== null && Array.isArray(textScripts) && value in textScripts) {
            var this_script = textScripts[value].script;

            leadFields.map((field) => {
                var text_value = field.includes('agent_') && selectedAgentIndex in agentData && field.replace('agent_','') in agentData[selectedAgentIndex] ? agentData[selectedAgentIndex][field.replace('agent_','')] : (leadData[field] || "");;
                if(field == "appraisal") {
                    text_value = !leadData[field] ? "$XX,XXX" : numberFormatter(leadData[field],true);
                }
                this_script = this_script.replaceAll('[' + field + ']',text_value || "");
            });

            setTextBody(this_script);
        }
    };   

    const [customerName,setCustomerName] = useState("");

    const [customerPhone,setCustomerPhone] = useState("");

    const sendText = async (e) => {
        e.preventDefault();
        
        const formData = Object.fromEntries(new FormData(e.target));
        
        const response = await sendSms(formData,leadData);

        if(response && response.success) {
            close();
            alert('Your text has been sent');
          } else alert('Error sending text');
    }

    const [textHistory, setTextHistory] = useState([]);

    useEffect(() => {
        if(leadData) {
            setCustomerName(leadData.first_name + " " + leadData.last_name);
            setCustomerPhone(leadData.phone);

            handleSelectChange(selectedOption);

            if(leadData.notes) {
              var text_history = [];
      
              leadData.notes.map((v,i) => {
                if(v.title == "Sent SMS" || v.title == "Received SMS") {
      
                  const createdAtDate = new Date(v.created_at + " UTC");
      
                  v.time = createdAtDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
                  v.date = createdAtDate.toLocaleString('en-US', { year: "2-digit", month: "2-digit", day: "numeric" });

                  v.received = v.title == "Received SMS";
      
                  text_history.push(v);
                }
              });
      
              setTextHistory(text_history.reverse());
            }
        }
    }, [leadData?.id]);
        
    useEffect(() => {

        if (agentData && Array.isArray(agentData)) {

            //selectAgent(agentData.findIndex((agent) => agent.email == leadData.agent_email));

            selectAgent(agentData.findIndex((agent) => agent.id == user.user_id));
        }

    },[agentData,user?.user_id]);

    useEffect(() => {
        if(textScripts && Array.isArray(textScripts)) handleSelectChange(0);
    }, [textScripts]);

    useEffect(() => {
        handleSelectChange(selectedOption);
    },[selectedAgentIndex]);
  
    return (
        <>
            {/* {console.log("textLeadItem", textLeadItem)}
            {console.log("formikData", formikData)} */}

                <form className='custom-form form-style2' onSubmit={(e) => sendText(e)}>
                    <div className="modal-header">
                        <h1 className="modal-title text-uppercase" id="staticBackdropLabel">Text Lead {leadData.vehicle_name ? " - " + leadData.vehicle_name : ""} {leadData.status ? " - " + leadData.status : ""}</h1>
                        <button className="sm-box-close" type="button" onClick={() => {
                            //resetForm(); // Reset the form when close button is clicked
                            close();
                        }}><i className="fa-solid fa-xmark"></i></button>
                    </div>
                    <div className="modal-body px-3 py-4">
                        <div className="text-end mb-2 d-none d-lg-block">
                        <button
                            onClick={() => {
                            close();
                            onAddScriptBtnClick("text");
                            }}
                            className="text-nowrap blue-transparent-btn dark-transparent-btn text-uppercase"
                            type="button"
                        >
                            <span className="blue-add-icon"></span> Add script
                        </button>
                        </div>
                        <div className='row'>
                            <div className='col-md-4'>
                                <div className='form-group mb-3'>
                                    <label>Select Sender</label>
                                    <select
                                        name="agent_email"
                                        className="form-control"
                                        onChange={(e) => selectAgent(e.target.value)}
                                        value={selectedAgentIndex}
                                    >
                                        {agentData.map((agent, i) =>
                                            <option key={i} value={i} style={{display:agent.lead_type == "ALL" || agent.lead_type == "Web" ? "" : "none"}}>{agent.full_name}</option>                                     
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='form-group mb-3'>
                                    <label>CUSTOMER NAME</label>
                                    <input type="text" name="name" className="form-control" value={customerName || ""} onChange={(e) => setCustomerName(e.target.value)}/>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='form-group mb-3'>
                                    <label>PHONE#</label>
                                    <input type="text" name="phone" className="form-control" value={customerPhone || ""} onChange={(e) => setCustomerPhone(e.target.value)}/>
                                </div>
                            </div>
                            <div className='col-12 mb-3 text-history'>
                                <div className='form-group'>
                                    <label>TEXT HISTORY</label>
                                    {/* <Field type="text" name="texthirstory" className="form-control" /> */}
                                    <div className="modal-chat-sec">
                                        <div className="modal-chat-sec-scroll" id="text-history">
                                        {textHistory.map((v,i) => {
                                            return (
                                                <div key={i}>
                                                    <div className="chat-date">{v.date}</div>
                                                    <div className="message-wrap">
                                                        <div className={(v.received ? "other-message" : "me-message") + " msgitem"}>
                                                            {v.note}
                                                            {'media' in v && Array.isArray(v.media) && <Fancybox
                                                                options={{
                                                                    Carousel: {
                                                                        infinite: false,
                                                                    },
                                                                }}
                                                            >
                                                                {v.media.map((image,j) =>          

                                                                        <a  data-fancybox="gallery" href={image} target="_blank">
                                                                            <img src={image}  />
                                                                        </a>
                                                                )}
                                                                {v.media.length > 1 ? <div className='vi-count'>+{v.media.length}</div> : ""}
                                                            </Fancybox>}
                                                        </div>
                                                        <div className={v.received ? "other-msg-time" : "me-msg-time"}>{v.time}</div>                                                       
                                                    </div>
                                                </div>
                                            )
                                        })}
   
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group mb-3'>
                                    <label>SELECT SCRIPT</label>
                                    <select name="script" className="form-control"
                                        onChange={(e) => handleSelectChange(e.target.value)}
                                        value={selectedOption}>
                                            {textScripts.map((script,i) => 
                                                <option key={i} value={i} style={{display:script.web ? "" : "none"}}>{script.script_name}</option>
                                            )}
                                    </select>
                                </div>
                                <div className='text-center d-none d-md-block'>
                                    <button className='blue-btn text-uppercase' type='submit'>
                                        <i className="bi bi-envelope-fill me-1"></i> Send Text
                                    </button>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group mb-3'>
                                    <label>MESSAGE</label>
                                    <textarea className="msgitem msgItem1 form-control h260" name="message" value={textBody} onChange={(e) => setTextBody(e.target.value)}></textarea>
                                </div>
                            </div>
                            <div className='col-12 text-center d-md-none'>
                                <button className='blue-btn text-uppercase mnw-170' type='submit'>
                                    <i className="bi bi-envelope-fill me-1"></i> Send Text
                                </button>
                            </div>
                        </div>
                    </div >
                </form>

        </>
    )
}

export default TextLead